import React from 'react';

export const HubSpotIcon = (): React.JSX.Element => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect
				x="-115.5"
				y="-406.5"
				width="1941"
				height="891"
				rx="4.5"
				stroke="#9747FF"
				strokeDasharray="10 5"
			/>
			<rect width="32" height="32" rx="8" fill="#FF5C35" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.7267 9.81495V12.354C24.1316 12.7088 26.0529 14.4518 26.5457 16.726C27.0386 19.0003 25.9994 21.3274 23.9391 22.5635C21.8788 23.7995 19.2307 23.6843 17.2968 22.2746L15.1343 24.3383C15.1904 24.5057 15.2201 24.6801 15.2227 24.8558C15.2227 25.5882 14.7603 26.2486 14.0513 26.5288C13.3422 26.8091 12.5261 26.6542 11.9834 26.1363C11.4407 25.6184 11.2784 24.8395 11.5721 24.1629C11.8658 23.4863 12.5577 23.045 13.3251 23.045C13.5093 23.0476 13.692 23.076 13.8675 23.1293L16.0534 21.0432C14.6752 19.1722 14.6396 16.6862 15.9637 14.7799L8.78076 9.44358C8.4342 9.63626 8.04058 9.73846 7.63949 9.73989C6.3644 9.73843 5.33197 8.75082 5.3335 7.53399C5.33502 6.31718 6.36992 5.33192 7.64501 5.33338C8.9201 5.33483 9.95253 6.32244 9.95101 7.53927C9.94803 7.72494 9.92021 7.90949 9.86821 8.08843L17.1739 13.513C17.9709 12.9014 18.9231 12.5016 19.934 12.354V9.81495C19.2163 9.49505 18.7563 8.80883 18.7527 8.05287V7.99361C18.7557 6.91618 19.6702 6.04347 20.7993 6.04058H20.8613C21.9904 6.04347 22.9049 6.91618 22.9079 7.99361V8.05287C22.9044 8.80883 22.4444 9.49505 21.7267 9.81495ZM17.8387 17.8509C17.8387 19.4277 19.1782 20.706 20.8306 20.706C22.483 20.706 23.8225 19.4277 23.8225 17.8509C23.8225 16.274 22.483 14.9957 20.8306 14.9957C19.1782 14.9957 17.8387 16.274 17.8387 17.8509Z"
				fill="white"
			/>
		</svg>
	);
};
